import { Button, Icon, Spinner } from "@servicetitan/design-system";
import { useDependencies } from "@servicetitan/react-ioc";
import classNames from "classnames";
import { observer } from "mobx-react";
import { FC } from "react";
import { NavLink } from "react-router-dom";
import { EHModule } from "../../api/eh.api";
import { EhWidgetEventType } from "../../constants/event-types";
import { EHStore } from "../../stores/eh.store";
import * as Styles from "./eh-modules-header-list-button.module.scss";

interface EHModulesHeaderListButtonProps {
    module: EHModule;
}

export const EHModulesHeaderListButton = ({ module }: EHModulesHeaderListButtonProps) => {
    switch (module.appType) {
        case "widget":
            return <EHModulesHeaderWidgetButton module={module} />;
        case "route":
            return <EhModulesHeaderRouteButton module={module} />;
        default:
            return null;
    }
}

export const EHModulesHeaderWidgetButton: FC<EHModulesHeaderListButtonProps> = observer(({ module }) => {
    const [{ widgetModules, setWidgetModuleState }] = useDependencies(EHStore);
    const widget = widgetModules.get(module.apiScope)!;

    const handleClick = () => {
        if (widget.isLoaded) {
            widget.eventBus?.emit(EhWidgetEventType.ModuleLinkClicked);
        } else {
            setWidgetModuleState(module.apiScope, { isOpenScheduled: true });
        }
    };

    const icon = widget.isOpenScheduled ? (
        <Spinner />
      ) : (
        <Icon name={module.icon ?? "border_clear"} color="#fff" />
      );      

    return (
        <Button
            fill="none"
            icon={icon}
            onClick={handleClick}
            disabled={widget.isOpenScheduled}
        />
    )
});

export const EhModulesHeaderRouteButton: FC<EHModulesHeaderListButtonProps> = ({ module }) => {
    return (
        <NavLink
            to={module.path}
            className={(isActive) => classNames(
                Styles.navItem,
                { [Styles.active]: isActive }
            )}
        >
            <Button
                fill="none"
                icon={<Icon name={module.icon ?? "border_clear"} color="#fff" />}
            />
        </NavLink>
    );
};